import * as React from 'react';
import { Loader } from "@progress/kendo-react-indicators";

const Loading = () => {
   
    return(  
    <div className="k-loading-mask">
        <div className="k-loading-image"></div>
        <div className="k-loading-color"></div>
    </div>
    )
}

export default Loading;
 